import { createFeatureSelector, createSelector } from '@ngrx/store';
import { affiliateFeatureKey, AffiliateState } from './affiliate.reducers';

export const selectAffiliateState = createFeatureSelector<AffiliateState>(affiliateFeatureKey);

export const selectAffiliateList = createSelector(selectAffiliateState, (state: AffiliateState) => state.affiliateList);

export const selectAffiliateTotalItems = createSelector(
  selectAffiliateState,
  (state: AffiliateState) => state.totalItems || 0
);

export const selectLoading = createSelector(selectAffiliateState, (state: AffiliateState) => state.loading);

export const selectError = createSelector(selectAffiliateState, (state: AffiliateState) => state.error);

export const selectAffiliateListRequestData = createSelector(
  selectAffiliateState,
  (state: AffiliateState) => state.requestData
);

export const selectTransactions = createSelector(selectAffiliateState, (state: AffiliateState) => state.transactions);

